import { render, staticRenderFns } from "./PublicFriendsRating.vue?vue&type=template&id=fa729a60&"
import script from "./PublicFriendsRating.vue?vue&type=script&lang=js&"
export * from "./PublicFriendsRating.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports